module.exports = __webpack_public_path__ + "img/edit-alt.52ed8cf5.svg";